import { render, staticRenderFns } from "./PreparationVisaLegend.vue?vue&type=template&id=4ba3f1ad&"
import script from "./PreparationVisaLegend.vue?vue&type=script&lang=js&"
export * from "./PreparationVisaLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports